// CRISPYzza Mock Data

export const heroData = {
  tagline: "The New Language of Italian Pizza",
  headline: "This is not pizza.",
  subheadline: "This is CRISPYzza",
  description: "A luxury gourmet revolution at a fast-food price starts here",
  ctaText: "Discover Our Menu"
};

export const chefData = {
  name: "Chef Francesco Romano",
  title: "Italian Heritage, Modern Vision",
  description: "A revolution born from Italian craftsmanship. Chef Francesco brings decades of culinary expertise from Italy to create a lighter way to enjoy an unforgettable pleasure.",
  quote: "I wanted to create something that honors Italian tradition while embracing modern nutrition. CRISPYzza is that dream realized.",
  image: "/images/image4.jpeg",
  image2: "/images/image15.jpeg"
};

export const coreFeatures = [
  {
    id: 1,
    title: "Light",
    description: "A revolutionary soy-based crispy base that's lighter than traditional pizza",
    icon: "Feather"
  },
  {
    id: 2,
    title: "Protein-Rich",
    description: "Packed with plant-based protein for sustained energy",
    icon: "Zap"
  },
  {
    id: 3,
    title: "Soy-Based",
    description: "Revolutionary soy-based crispy base for a lighter experience",
    icon: "Leaf"
  },
  {
    id: 4,
    title: "Addictive",
    description: "The crunch you hear before you taste it",
    icon: "Sparkles"
  }
];

export const valueProposition = [
  {
    id: 1,
    title: "Italian Soul",
    description: "Authentic Italian recipes perfected over generations"
  },
  {
    id: 2,
    title: "Healthy Nutrition",
    description: "Designed for modern nutrition without sacrificing indulgence"
  },
  {
    id: 3,
    title: "Best Gourmet Taste",
    description: "Premium ingredients creating unforgettable flavors"
  },
  {
    id: 4,
    title: "Unforgettable Crunch",
    description: "You hear it before you taste it"
  }
];

export const menuItems = [
  {
    id: 1,
    name: "Margherita Classica",
    description: "Fresh mozzarella, San Marzano tomatoes, basil, extra virgin olive oil",
    image: "/images/image3.jpg",
    category: "classic",
    tags: ["vegetarian", "halal"]
  },
  {
    id: 2,
    name: "Prosciutto e Brie",
    description: "Italian prosciutto, creamy brie cheese, walnuts, fresh chives",
    image: "/images/image7.jpg",
    category: "gourmet",
    tags: ["signature", "halal"]
  },
  {
    id: 3,
    name: "Fusion Tropicale",
    description: "Avocado base, tuna tartare, mango, pomegranate seeds",
    image: "/images/image5.jpg",
    category: "fusion",
    tags: ["healthy", "halal"]
  },
  {
    id: 4,
    name: "Halal Spicy Salami",
    description: "Spicy halal salami, mozzarella, rich tomato sauce",
    image: "/images/image12.jpg",
    category: "classic",
    tags: ["classic", "halal"]
  },
  {
    id: 5,
    name: "Caprese Delight",
    description: "Fresh ricotta, cherry tomatoes, basil, black pepper",
    image: "/images/image6.jpg",
    category: "classic",
    tags: ["vegetarian", "halal"]
  },
  {
    id: 6,
    name: "Chef's Collection",
    description: "A tasting journey featuring our signature creations",
    image: "/images/image2.jpg",
    category: "collection",
    tags: ["signature", "halal"]
  }
];

export const experienceData = {
  tagline: "Complete Gourmet Dining",
  headline: "A tasting journey, not a portion",
  items: [
    {
      number: "01",
      title: "One is a temptation",
      description: "The first bite awakens your senses"
    },
    {
      number: "02",
      title: "Two is a ritual",
      description: "The experience becomes a tradition"
    },
    {
      number: "03",
      title: "Three is an experience",
      description: "A complete gourmet journey"
    }
  ]
};

export const whereItBelongs = [
  {
    id: 1,
    title: "Delivery",
    description: "Fresh to your doorstep",
    icon: "Truck"
  },
  {
    id: 2,
    title: "Premium Food Courts",
    description: "In the finest malls",
    icon: "Store"
  },
  {
    id: 3,
    title: "Hospitality",
    description: "Hotels & restaurants",
    icon: "Hotel"
  },
  {
    id: 4,
    title: "Events",
    description: "Catering for special occasions",
    icon: "PartyPopper"
  }
];

export const halalData = {
  title: "Halal Excellence",
  subtitle: "Designed for the UAE without compromise",
  description: "All our ingredients are certified Halal, ensuring everyone can enjoy the CRISPYzza experience with complete confidence.",
  certifications: ["Halal Certified", "Quality Assured", "100% Premium Ingredients"]
};

export const footerData = {
  brand: "CRISPYzza",
  tagline: "By Chef Francesco",
  description: "Italian soul. Healthy nutrition. Best gourmet taste. Unforgettable crunch.",
  contact: {
    email: "info@architaly.green",
    phone: "+971 55 947 2027"
  },
  social: [
    { name: "Instagram", url: "#" },
    { name: "Facebook", url: "#" },
    { name: "Twitter", url: "#" }
  ]
};
